import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from '../guards/auth.guard';
import { PlanGuard } from '../guards/plan.guard';
import { AppService } from '../app.service';
import { SafetyObservationsComponent } from './safety-observations/safety-observations.component';

const routes: Routes = [
  {
    path: 'safety-observations',
    component: SafetyObservationsComponent,
    canActivate: [
      AuthGuard,
      PlanGuard
    ],
    data: { planFeature: AppService.FEATURES.SAFETY_OBSERVATIONS }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SafetyObservationsRoutingModule { }
